import { TellescopeModelFromName } from "@tellescope/tanstack-query";
import { Button, cn } from "@tellescope/design-system";
import { useTranslation } from "react-i18next";
import { useMedicationDisplay } from "./useMedicationDisplay";

export interface MedicationDetailsProps {
  medication: TellescopeModelFromName<"enduser_medications">;
  onBack: () => void;
  className?: string;
}

export const MedicationDetails = ({ medication, onBack, className }: MedicationDetailsProps) => {
  const { t } = useTranslation("contacts");
  const getDisplayFields = useMedicationDisplay();
  const { dosage, statusLabel, date } = getDisplayFields(medication);

  return (
    <div className={cn("flex flex-col gap-3 text-left", className)}>
      <Button variant="link" color="secondary" size="sm" className="h-auto self-start p-0" onClick={onBack}>
        {t("All medications")}
      </Button>

      <div className="flex flex-col gap-1 rounded-lg border bg-background px-4 py-3">
        <p className="text-sm font-semibold text-foreground">{medication.title}</p>
        <p className="text-xs text-muted-foreground">{dosage}</p>

        <div className="mt-2 flex items-end justify-between gap-4">
          <p className="min-w-0 truncate text-xs text-muted-foreground">{statusLabel}</p>
          <p className="shrink-0 text-xs text-muted-foreground">{date}</p>
        </div>
      </div>
    </div>
  );
};
